module.exports = __webpack_public_path__ + "static/media/mark_vermelho.cbc78d5f.svg";